module.exports = __webpack_public_path__ + "static/media/pm.c993eb40.svg";